module.exports = "/images/pillCarIcon.png?a6ff6227ffacaf10470a6a2eddd5c597";